// react
import React from 'react';

// third-party
import ReactDOM from 'react-dom';

// application
import * as serviceWorker from './serviceWorker';

// styles
import './index.css'
import App from './components/App';



ReactDOM.render((
        <App />
), document.getElementById('root'));

serviceWorker.unregister();
